import { useCallback, useEffect, useRef } from 'react';

const useClickOutside = (callback) => {
  const ref = useRef(null);

  const keyboardListener = useCallback(
    (event) => {
      if (event.key === 'Escape') {
        callback();
      }
    },
    [callback]
  );

  const mouseListener = useCallback(
    (event) => {
      if (ref.current) {
        if (!ref.current.contains(event.target)) {
          callback();
        }
      }
    },
    [callback]
  );

  useEffect(() => {
    document.addEventListener('keyup', keyboardListener);
    document.addEventListener('click', mouseListener);

    return () => {
      document.removeEventListener('keyup', keyboardListener);
      document.removeEventListener('click', mouseListener);
    };
  }, [keyboardListener, mouseListener]);

  return ref;
};

export default useClickOutside;
